import { useEffect, useMemo, useState } from "react";
import { axiosInstance } from "../../Api/config";
import Loader from "../Loader";

const ACTION_COLORS = {
  LOGIN: "bg-blue-100 text-blue-700",
  CREATE: "bg-green-100 text-green-700",
  UPDATE: "bg-yellow-100 text-yellow-700",
  DELETE: "bg-red-100 text-red-700",
  APPROVE: "bg-emerald-100 text-emerald-700",
  REJECT: "bg-rose-100 text-rose-700",
  EXPORT: "bg-purple-100 text-purple-700",
  CHECK_AADHAAR: "bg-indigo-100 text-indigo-700",
  SCAN_AADHAAR: "bg-cyan-100 text-cyan-700",
};

const Log = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filters
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");
  const [action, setAction] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
const stats = useMemo(() => {
  const today = new Date().toDateString();

  const todayLogs = logs.filter(
    (l) => new Date(l.createdAt).toDateString() === today
  );

  const uniqueUsers = new Set(logs.map((l) => l.username));

  const actionCount = {};
  logs.forEach((l) => {
    actionCount[l.action] = (actionCount[l.action] || 0) + 1;
  });

  return {
    total: logs.length,
    today: todayLogs.length,
    users: uniqueUsers.size,
    loginCount: actionCount.LOGIN || 0,
    actionCount,
  };
}, [logs]);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await axiosInstance.get("/logs");
      setLogs(res.data.data || []);
    } catch (err) {
      console.error("Failed to fetch logs", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ FILTER LOGIC
  const filteredLogs = useMemo(() => {
    return logs.filter((log) => {
      const text = `${log.username} ${log.action} ${log.module}`.toLowerCase();
      if (search && !text.includes(search.toLowerCase())) return false;
      if (role && log.role !== role) return false;
      if (action && log.action !== action) return false;

      const logDate = new Date(log.createdAt);
      if (fromDate && logDate < new Date(fromDate)) return false;
      if (toDate && logDate > new Date(toDate + "T23:59:59")) return false;

      return true;
    });
  }, [logs, search, role, action, fromDate, toDate]);

  if (loading) return <Loader />;

  return (
    <div className="p-5">
     
{/* ================= LOG DASHBOARD ================= */}
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">

  <div className="p-5 rounded-xl bg-gradient-to-r from-indigo-500 to-indigo-600 text-white shadow">
    <p className="text-sm opacity-80">Total Activities</p>
    <p className="text-3xl font-bold">{stats.total}</p>
  </div>

  <div className="p-5 rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow">
    <p className="text-sm opacity-80">Today</p>
    <p className="text-3xl font-bold">{stats.today}</p>
  </div>

  <div className="p-5 rounded-xl bg-gradient-to-r from-blue-500 to-cyan-600 text-white shadow">
    <p className="text-sm opacity-80">Active Users</p>
    <p className="text-3xl font-bold">{stats.users}</p>
  </div>

  <div className="p-5 rounded-xl bg-gradient-to-r from-purple-500 to-fuchsia-600 text-white shadow">
    <p className="text-sm opacity-80">Logins</p>
    <p className="text-3xl font-bold">{stats.loginCount}</p>
  </div>

</div>

      {/* ================= FILTER BAR ================= */}
      <div className="bg-white p-4 rounded-xl shadow mb-5 grid grid-cols-1 md:grid-cols-5 gap-3">
        <input
          placeholder="Search username / action / module"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border rounded-lg px-3 py-2"
        />

        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          className="border rounded-lg px-3 py-2"
        >
          <option value="">All Roles</option>
          <option value="admin">Admin</option>
          <option value="branchUser">Branch User</option>
        </select>

        <select
          value={action}
          onChange={(e) => setAction(e.target.value)}
          className="border rounded-lg px-3 py-2"
        >
          <option value="">All Actions</option>
          {[...new Set(logs.map((l) => l.action))].map((a) => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>

        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="border rounded-lg px-3 py-2"
        />

        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="border rounded-lg px-3 py-2"
        />
      </div>

      {/* ================= TABLE ================= */}
      <div className="overflow-x-auto bg-white rounded-xl shadow">
        <table className="min-w-full border-collapse">
          <thead className="sticky top-0 bg-gray-100">
            <tr>
              <th className="border px-3 py-2 text-left">User</th>
              <th className="border px-3 py-2 text-left">Role</th>
              <th className="border px-3 py-2 text-left">Action</th>
              <th className="border px-3 py-2 text-left">Module</th>
              <th className="border px-3 py-2 text-left">Date</th>
              <th className="border px-3 py-2 text-left">Time</th>
            </tr>
          </thead>

          <tbody>
            {filteredLogs.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500">
                  No logs match filters
                </td>
              </tr>
            ) : (
              filteredLogs.map((log) => {
                const d = new Date(log.createdAt);
                return (
                  <tr key={log._id} className="hover:bg-gray-50">
                    <td className="border px-3 py-2 font-medium">
                      {log.username}
                    </td>

                    <td className="border px-3 py-2">
                      <span className="px-2 py-1 rounded-full text-xs bg-gray-200">
                        {log.role}
                      </span>
                    </td>

                    <td className="border px-3 py-2">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${
                          ACTION_COLORS[log.action] || "bg-gray-100 text-gray-700"
                        }`}
                      >
                        {log.action}
                      </span>
                    </td>

                    <td className="border px-3 py-2">{log.module}</td>

                    <td className="border px-3 py-2">
                      {d.toLocaleDateString("en-IN")}
                    </td>

                    <td className="border px-3 py-2">
                      {d.toLocaleTimeString("en-IN")}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* FOOTER */}
      <p className="text-sm text-gray-500 mt-3">
        Showing {filteredLogs.length} of {logs.length} logs
      </p>
    </div>
  );
};

export default Log;
